export const GET_BANK_DETAILS = 'GET_BANK_DETAILS';
export const CREATE_BANK_DETAIL  = 'CREATE_BANK_DETAIL';
export const BANK_DETAIL_REQUEST  = 'BANK_DETAIL_REQUEST';
export const DELETE_BANK_DETAIL  = 'DELETE_BANK_DETAIL';
export const UPDATE_BANK_DETAIL  = 'UPDATE_BANK_DETAIL';
export const BANK_DETAIL_REQUEST_FAILURE  = 'BANK_DETAIL_REQUEST_FAILURE';
export const GET_BANK_DETAILS_PAGE = 'GET_BANK_DETAILS_PAGE';
export const BANK_DETAIL_REQUEST_SUCCESS = 'BANK_DETAIL_REQUEST_SUCCESS';